import { lightTheme } from "@/customTheme";
import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={6}
      y={3}
      width={12}
      height={18}
      rx={2}
      stroke={lightTheme.colors.blackGray}
      strokeWidth={2}
    />
  </svg>
);
export default SVGComponent;
